// extracted by mini-css-extract-plugin
export var boxItems = "_71-1";
export var button = "_71-5";
export var filterGroupBox = "_71-0";
export var icon = "_71-2";
export var iconSecondary = "_71-4";
export var iconWrapper = "_71-3";